<template>
  <div class="corporateTraining">
    <app-CorporateTrainingHero></app-CorporateTrainingHero>
    <div class="container">
      <div class="centered">
        We Offer Flexible Payment
        to Business Customers
      </div>
      <div class="row optionbox">
        <div class="col-sm-12 col-md-8">
          <div>
            <div class="optionstyle">OPTION 1</div>
            <p class="optionpara">Offering minimum 15% discount if 3 or more employee attends, valid for all workshops throughout the year.</p>
            <h2 class="optionstyle">OPTION 2</h2>
            <p class="optionpara">For corporates and businesses, we also offer bulk buying in order to reduce the overall cost of training your employees. Corporate bulk deals are done under Purchase Orders (PO) sent by the company, where the advancement can be one quarter to a full year. Your employees can simply register for workshops(s) and we’ll take care of the rest! We ensure a better value for money for YOU!</p>
          </div>
        </div>
        <div class="col-sm-12 col-md-4">
          <img src="../assets/Magnito-Client-Privilege-Program-3.png" class="floating-img">
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-12">
          <div class="centered">
            Some of our clients
          </div>
        </div>
        <div class="col-md-12 text-center">
          <div class="ulogo-container">
            <img src="../assets/magnito.png" class="ulogo">
            <img src="../assets/bongo.png" class="ulogo">
            <img src="../assets/iml.png" class="ulogo">
          </div>
        </div>
        <div class="col-md-12 text-center gap100">
          <div class="ulogo-container">
            <img src="../assets/lcp-logo.png" class="ulogo">
            <img src="../assets/shohoz.png" class="ulogo">
          </div>
        </div>
      </div>
      <div class="row justify-content-center" style="background: #F8F8F9 0% 0% no-repeat padding-box; padding: 100px;">
          <div class="col-md-12">
              <div class="sectionheader">Why Companies Choose Upskill</div>
          </div>
          <div class="col-md-12">
              <div class="subc">
                  <div class="row">
                      <div class="col-md-2">
                          <img src="../assets/p1.png" alt="">
                      </div>
                      <div class="col-md-10">
                          <div class="subh">Custom Learning</div>
                          <div class="subp">
                              Get continuous adaptive learning content tailored to your changing business needs. We can customize based on your preferences.
                          </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-md-2">
                          <img src="../assets/p2.png" alt="">
                      </div>
                      <div class="col-md-10" style="margin-top: auto; margin-bottom: auto">
                          <div class="subh">Save Money</div>
                          <div class="subp">
                              By ordering customized training content that only suit your teams’ or even a single employee’s learning needs
                          </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-md-2">
                          <img src="../assets/p3.png" alt="">
                      </div>
                      <div class="col-md-10">
                          <div class="subh">Expert Trainers</div>
                          <div class="subp">
                              Get access to local and global industry veterans from companies like LightCastle Partners, Magnito Digital, Bongo Studios, IFC, IBM and more.
                          </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-md-2">
                          <img src="../assets/p4.png" alt="">
                      </div>
                      <div class="col-md-10">
                          <div class="subh">Test-Based Learning</div>
                          <div class="subp">
                              Our platform leverages digital tools to facilitate assignment and test-based learning to ensure delivery of instantly applicable skills
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
      <div style="background: #728391 0% 0% no-repeat padding-box;" class="gap100">
          <div class="row" style="max-width: 1350px; margin-left: auto; margin-right: auto;">
              <div class="col-md-12">
                  <div class="centered text-white">How it Works</div>
              </div>
              <div class="col-md-4 text-center">
                  <div class="steph">
                      Step 01
                  </div>
                  <div class="stepp">
                      Registration
                  </div>
                  <img src="../assets/step-2.png" alt="">
              </div>
              <div class="col-md-4 text-center">
                  <div class="steph">
                      Step 02
                  </div>
                  <div class="stepp">
                      Attend Workshop
                  </div>
                  <img src="../assets/step-3.png" alt="">
              </div>
              <div class="col-md-4 text-center">
                  <div class="steph">
                      Step 03
                  </div>
                  <div class="stepp">
                      Review courses in future
                  </div>
                  <img src="../assets/step-1.png" alt="">
              </div>
          </div>
      </div>
      <div class="container infoBox" style="margin-bottom: 100px;">
          <div class="infoBoxContainer justify-content-center">
              <div class="infoBoxHeader1">
                  Upskill
              </div>
              <div class="infoBoxHeader2">
                  Upskill Employer Sponsorship
              </div>
              <div class="infoBoxHeaderP" style="padding-bottom: 90px;">
                  Please ask your boss to fund your training. Your new skills make you a more valuable employee, so everybody wins.
              </div>
<!--              <ubtn style="margin-bottom: 90px;">Register</ubtn>-->
          </div>
      </div>
    <app-AboutTraining></app-AboutTraining>
    <app-TrainingBenefits></app-TrainingBenefits>
    <app-ContactUs></app-ContactUs>
  </div>
</template>
<script>
import corporateTrainingHero from "../components/corporateTraining/corporateTrainingHero";
import aboutTraining from "../components/corporateTraining/aboutTraining";
import trainingBenefits from "../components/corporateTraining/trainingBenefits";
import contactUs from "../components/corporateTraining/contactUs";
export default {
  name: "corporateTraining",
  components: {
    appCorporateTrainingHero: corporateTrainingHero,
    appAboutTraining: aboutTraining,
    appTrainingBenefits: trainingBenefits,
    appContactUs: contactUs
  },
  created() {
    this.Loaded();
  }
};
</script>

<style>
  .floating-img {
    /*width: 464px;*/
    top: -150px;
    height: 465px;
    position: absolute;
  }

  .ulogo {
    max-width: 224px;
    padding-left: 92px;
    margin-right: 92px;
  }
  .ulogo-container {
    margin: 0 auto;
  }
  .centered {
    text-align: center; font: Bold 32px/40px Montserrat; max-width: 524px; margin:auto; padding-bottom: 80px; padding-top: 40px;
  }
  .scentered {
    max-width: 900px; margin:auto;
  }
  .optionbox {
    background: #728391 0% 0% no-repeat padding-box;
    opacity: 1; padding-left: 195px; padding-top: 95px; padding-bottom: 95px
  }
  .optionstyle {
    font: Bold 24px/29px Open Sans;
    letter-spacing: 0px;
    color: #FFFFFF;
  }
  .optionpara {
    font: Regular 18px/29px Open Sans;
    letter-spacing: 0px;
    color: #FFFFFF;
  }

  .sectionheader {
    text-align: center;
    font: Bold 32px/40px Montserrat;
    letter-spacing: -0.8px;
    color: #000000;
    text-transform: capitalize;
    margin-left: auto;
      margin-right: auto;
      margin-bottom: 50px;
  }
  .subh {
    font: Bold 24px/29px Open Sans;
    letter-spacing: 0px;
    color: #000000;
  }
  .subp {
    font: Regular 18px/29px Open Sans;
    letter-spacing: 0px;
    color: #000000;
      padding-bottom: 57px;
  }
    .subc {
        max-width: 890px;
        margin-left: auto;
        margin-right: auto;
    }
    .steph {
        font: Bold 24px/40px Montserrat;
        letter-spacing: 4.8px;
        color: #FFFFFF;
        text-transform: uppercase;
    }
    .stepp {
        font: 24px/32px Open Sans;
        font-weight: 200;
        color: white;
        letter-spacing: 0px;
    }
    .gap100 {
        margin-top: 100px;
        margin-bottom: 100px;
    }
    .infoBox {
        max-width: 1250px;
        border-radius: 20px;
        background: transparent linear-gradient(257deg, #00FFA8 0%, #6700B5 100%) 0% 0% no-repeat padding-box;
    }
    .infoBoxContainer {
        max-width: 515px;
        margin: 0 auto;
    }
    .infoBoxHeader1 {
        text-align: left;
        font: 24px/60px Montserrat;
        letter-spacing: -0.6px;
        color: #FFFFFF;
        text-transform: uppercase;
        padding-top: 90px;
    }
  .infoBoxHeader2 {
      font: 48px/60px Montserrat;
      letter-spacing: -1.2px;
      color: #FFFFFF;
  }
    .infoBoxHeaderP {
        text-align: left;
        font: 18px/29px Open Sans;
        letter-spacing: 0px;
        color: #FFFFFF;
    }

  @media screen and (max-width: 600px) {
      .infoBoxContainer {
          padding: 20px;
      }
      .floating-img {
          /*width: 464px;*/
          height: 465px;
          position: unset;
      }
      .optionbox {
          padding: 20px 10px;
      }
  }
</style>
